import { Space, Spin } from 'antd';

import styles from './Loader.module.css';

const PageLoader = () => {
  return (
    <Space data-testid="PageLoader" className={styles.LoaderWrapper}>
      <Spin size="large" />
    </Space>
  );
};

export default PageLoader;
